import { render, staticRenderFns } from "./vip-choose-free.vue?vue&type=template&id=03d8a27d&scoped=true&"
import script from "./vip-choose-free.vue?vue&type=script&lang=js&"
export * from "./vip-choose-free.vue?vue&type=script&lang=js&"
import style0 from "./vip-choose-free.vue?vue&type=style&index=0&id=03d8a27d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d8a27d",
  null
  
)

export default component.exports